import { useRef, useState } from 'react'
import './Contacto.css'
import emailjs from '@emailjs/browser';





function Contacto() {

    const [enviar, setEnviar] = useState(false)
    const form = useRef();

    function Enviado(e) {
        e.preventDefault();
        const formElement = form.current;

        if (!formElement.checkValidity()) {
            formElement.classList.add('was-validated');
            return;
        }

        formElement.classList.remove('was-validated');
        setEnviar(true);

        // 1️⃣ Email admin
        const sendAdmin = emailjs.sendForm(
            process.env.REACT_APP_EMAILJS_SERVICE,
            process.env.REACT_APP_EMAILJS_TEMPLATE_ADMIN,
            formElement,
            process.env.REACT_APP_EMAILJS_KEY
        );

        // 2️⃣ Auto-reply al usuario
        const sendAutoReply = emailjs.sendForm(
            process.env.REACT_APP_EMAILJS_SERVICE,
            process.env.REACT_APP_EMAILJS_TEMPLATE_AUTOREPLY,
            formElement,
            process.env.REACT_APP_EMAILJS_KEY
        );

        // Esperamos a que ambos se disparen antes de resetear
        Promise.all([sendAdmin, sendAutoReply])
            .then(() => {
                console.log('Ambos correos enviados con éxito');
                formElement.reset(); // <--- RESETEAR AQUÍ
                setTimeout(() => setEnviar(false), 6000);
            })
            .catch(error => {
                console.error('Error en el envío:', error);
                setEnviar(false);
            });
    }


    return (
        <div className='degradado contact-section'>
            <div className='servicios'>
                <h1 className='titulo dos'>CONTACTO </h1>
            </div>

            <div className='contact-glow' aria-hidden="true" />

            <div className='organizar'>
                <div className='envolver'>
                    <div className='explicar'>
                        <span className='explicar__icon' aria-hidden="true">
                            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                                <circle cx="12" cy="12" r="10"></circle>
                                <line x1="12" y1="16" x2="12" y2="12"></line>
                                <line x1="12" y1="8" x2="12.01" y2="8"></line>
                            </svg>
                        </span>
                        <p className='textServ center'>Para cualquier duda relacionada con los servicios que ofrecemos puede contactar con nosotros sin ningún compromiso rellenando el siguiente formulario.</p>
                    </div>
                    <div className='explicar'>
                        <span className='explicar__icon' aria-hidden="true">
                            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
                            </svg>
                        </span>
                        <p className='textServ center'>Al rellenar el formulario los datos serán utilizados para contactar con usted y estarán seguros ya que cumplimos con la ley RGPD (Reglamento General de Protección de Datos)</p>
                    </div>
                </div>


                <div className='formulario'>
                    <form method='POST' ref={form} onSubmit={Enviado}>
                        <div className="form-row">
                            <div className="col-md-4">
                                <label htmlFor="validationCustom01" className="form-label">Nombre</label>
                                <input type="text" className="form-control" id="validationCustom01" name="nombre" placeholder="Tu nombre" required pattern="^[a-zA-ZÀ-ÿ\s]+$"/>
                            </div>
                            <div className="col-md-4">
                                <label htmlFor="validationCustom02" className="form-label">Apellido</label>
                                <input type="text" className="form-control" id="validationCustom02" name="apellido" placeholder="Tu apellido" required pattern="^[a-zA-ZÀ-ÿ\s]+$"/>
                            </div>
                        </div>
                        <div className="mb-3">
                            <label htmlFor="exampleFormControlInput1" className="form-label">Email</label>
                            <input type="email" className="form-control" id="exampleFormControlInput1" name="email" placeholder="tu@email.com" required />
                        </div>
                        <div className="mb-3">
                            <label htmlFor="exampleFormControlTextarea1" className="form-label">Mensaje</label>
                            <textarea className="form-control" id="exampleFormControlTextarea1" name="mensaje" rows="4" placeholder="Cuéntanos en qué podemos ayudarte..."></textarea>
                        </div>
                        <div className="col-12">
                            <button className={`cta send-btn ${enviar ? "enviado" : ""}`} type="submit">
                                <span className="material-symbols-outlined">drone</span>
                                <span className='send-text'> Enviar</span>
                                <span className='sent-text'> Enviado</span>
                            </button>
                        </div>
                    </form>
                </div>

            </div>

        </div>
    )
}

export default Contacto

